<template>
  <div>
    <pageHeader :headerIcon="'bell'"
                :headerText="$t('notifications')"
                :haveFilterInput="false">
    </pageHeader>

    <div class="ui grid" style="padding-top: 20px;">
      <div class="one wide column"></div>
      <div class="thirteen wide column">
        <div class="ui divided items" v-if="$auth.user().notifications.length">
          <div class="item"
               v-for="notification in $auth.user().notifications"
               @click="goToTarget(notification)">
            <div class="ui image">
              <img src="~@/assets/image.png"
                   style="width: 75px !important; height: 75px !important;"
                   v-if="checkUser(notification.notifier_id)">
              <img class="ui medium circular image"
                   style="width: 75px !important; height: 75px !important;"
                   :src="getImagesAPIEndPoint() + getUserImage(getUser(notification.notifier_id))"
                   alt=""
                   v-else>
            </div>
            <div class="content" style="margin-top: 1.8%;">
              <div class="oneline">
                {{ notification.text }}
              </div>
              <div class="extra">
                {{ getPeriod(notification) }}
              </div>
            </div>
          </div>
        </div>

        <div class="ui placeholder segment" style="margin-bottom: 50px" v-else>
          <div class="ui icon header" style="color: #092442">
            <i class="dont icon"></i>
            {{ $t('thereAreNoNotificationsYet') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    pageHeader: require('@/components/abstract_components/PageHeader').default
  },
  methods: {
    checkUser (userId) {
      return window._.isEmpty(this.getUser(userId)) || this.getUser(userId).album.images.length < 1
    },
    getPeriod (notification) {
      let numOfMnuites = window.moment().diff(notification.created_at, 'minutes')
      if (numOfMnuites < 60) {
        return numOfMnuites + ' ' + this.$t(window.pluralize('minutes', numOfMnuites))
      } else if (numOfMnuites < 1441) {
        let numOfHours = window.moment().diff(notification.created_at, 'hours')
        return numOfHours + ' ' + this.$t(window.pluralize('hours', numOfHours))
      } else if (numOfMnuites < 10081) {
        let numOfDays = window.moment().diff(notification.created_at, 'days')
        return numOfDays + ' ' + this.$t(window.pluralize('days', numOfDays))
      } else if (numOfMnuites < 302401) {
        let numOfWeeks = window.moment().diff(notification.created_at, 'weeks')
        return numOfWeeks + ' ' + this.$t(window.pluralize('weeks', numOfWeeks))
      } else if (numOfMnuites < 3628801) {
        let numOfMonths = window.moment().diff(notification.created_at, 'months')
        return numOfMonths + ' ' + this.$t(window.pluralize('months', numOfMonths))
      } else {
        let numOfYears = window.moment().diff(notification.created_at, 'years')
        return numOfYears + ' ' + this.$t(window.pluralize('years', numOfYears))
      }
    },
    getImagesAPIEndPoint () {
      return this.axios.defaults.baseURL
    },
    goToTarget (notification) {
      if (notification.notifiable_type === 'User') {
        this.navigateTo(`Show_${this.getUsertype(notification.notifiable_id)}`, {
          key: 'params',
          value: { id: this.getUser(notification.notifiable_id).id }
        })
      } else if (notification.notifiable_type === 'Reservation') {
        this.navigateTo('Show_Reservation', { key: 'params', value: { id: notification.notifiable_id } })
      } else if (notification.notifiable_type === 'Patient') {
        this.navigateTo('Show_Patient', { key: 'params', value: { id: notification.notifiable_id } })
      }
    },
    getUsertype (notifiableId) {
      return window._.find(this.doctors, doctor => {
        return doctor.user.id === notifiableId
      }) ? 'Doctor' : 'Employee'
    },
    getUserImage (user) {
      return user.album.images[user.album.images.length - 1].picture.url
    },
    getUser (userId) {
      if (!this.doctors || !this.employees) return
      let objects = window._.concat(this.doctors, this.employees)

      return window._.find(objects, object => {
        return object.user.id === userId
      })
    },
    isApprovalRequest (notification) {
      return notification.notifiable_type === 'Approval::Request'
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/notifications/Notifications.vue